<template>
  <span v-if="workingQualifier">

    <v-row>
        <v-col cols="12">
          <v-select label="Qualification Method" outlined dense :items="Object.entries(CreditCardQualificationMethods)" v-model="workingQualifier.qualificationMethod"
            item-text="1" item-value="0" :rules="requiredRule" @input="onChange" ref="qualMethod"/>
        </v-col>
      </v-row>

      <template v-if="isQualMethodSelected() && !isQualTypeSpend()">
        <v-row class="mt-8">
            <v-col cols="12">
              <v-text-field
                label="Minimum Transaction Count"
                v-model="workingQualifier.minimumTransactionCount"
                type="number"
                hint="Ex. 2"
                hide-spin-buttons
                dense
                :rules="requiredAndPositiveRule"
                @input="onChange"
                name="minimumTransactionCount"
              />
            </v-col>
          </v-row>
          <v-row class="mt-6">
            <v-col cols="12">
              <v-text-field
                label="Minimum Transaction Amount"
                v-model="workingQualifier.minimumTransactionAmount"
                type="number"
                hint="Ex. 5.00"
                prefix="$"
                hide-spin-buttons
                dense
                :rules="requiredAndPositiveRule"
                @input="onChange"
                name="minimumTransactionAmount"
              />
            </v-col>
          </v-row>
      </template>

      <template v-if="isQualMethodSelected() && !isQualTypeCount()">
        <v-row class="mt-6">
          <v-col cols="12">
            <v-text-field
              label="Minimum Total Spend"
              v-model="workingQualifier.minimumTotalSpend"
              type="number"
              hint="Ex. 5.00"
              prefix="$"
              hide-spin-buttons
              dense
              :rules="requiredAndPositiveRule"
              @input="onChange"
              name="minimumTotalSpend"
              />
          </v-col>
        </v-row>
      </template>

    </span>
</template>

<script lang="ts">
import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { CreditCardQualifier, CreditCardQualificationMethods } from '@/api/product/levelrewards/qualifiers';
import { ValidationTool } from '@/util';

@Component
export default class CreditCardQualifierEditor extends Vue {
  @Prop()
  value!:CreditCardQualifier;

  workingQualifier:CreditCardQualifier | null = null;

  // Make visible to template
  CreditCardQualificationMethods:any = CreditCardQualificationMethods;


  requiredRule:Array<any> = [(value: any) => {
    if (value === null || value === undefined || (Array.isArray(value) && value.length === 0)) {
      return 'Required';
    }
    return true;
  }];

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  mounted() {
    this.initialize();
  }

  @Watch('value')
  initialize() {
    this.workingQualifier = this.value.clone() as CreditCardQualifier;
  }

  onChange() {
    if (this.isQualTypeSpend() && this.workingQualifier) {
      this.workingQualifier.minimumTransactionCount = null;
      this.workingQualifier.minimumTransactionAmount = null;
    } else if (this.isQualTypeCount() && this.workingQualifier) {
      this.workingQualifier.minimumTotalSpend = null;
    }

    this.$emit('input', this.workingQualifier);
  }

  isQualTypeSpend() {
    return this.workingQualifier && this.workingQualifier.qualificationMethod && this.workingQualifier.qualificationMethod === 'SPEND';
  }

  isQualTypeCount() {
    return this.workingQualifier && this.workingQualifier.qualificationMethod && this.workingQualifier.qualificationMethod === 'COUNT';
  }

  isQualMethodSelected() {
    return this.workingQualifier && this.workingQualifier.qualificationMethod;
  }
}
</script>

<style lang="scss" scoped>
</style>
